import { Nav } from 'react-bootstrap'
import { NavigationLink } from '../navigation-link'

export type MenuItemProps = {
  url?: string
  icon?: string
  name?: string
}

export const MenuItem = ({ url, icon, name }: MenuItemProps) => {
  return (
    <Nav.Item>
      <NavigationLink href={url} icon={icon} title={name} />
    </Nav.Item>
  )
}
